import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';

// Memoised: getFeatureValue builds a GrowthBook instance per call.
const useKaraokeEnabled = () => {
  const { getFeatureValue, isFeatureFlagsReady } = useFeatureFlags();
  const userId = useSelector((state) => state.auth.user.id);
  const email = useSelector((state) => state.auth.user.email);
  const phoneNumber = useSelector((state) => state.auth.user.phoneNumber);

  return useMemo(
    () =>
      Boolean(
        getFeatureValue(FEATURE_KEYS.VIDEO_DUBBING_CAPTION_KARAOKE, {
          userId,
          email,
          phoneNumber,
        }),
      ),
    [isFeatureFlagsReady, userId, email, phoneNumber],
  );
};

export default useKaraokeEnabled;
